import { defineMessages } from 'react-intl';

const messages = defineMessages({
  blockTitle: {
    id: 'agendaSummaryBlock.blockTitle',
    defaultMessage: 'Agenda Summary',
  },
  title: {
    id: 'agendaSummaryBlock.title',
    defaultMessage: 'Agenda Summary',
  },
  layout: {
    id: 'agendaSummaryBlock.layout',
    defaultMessage: 'Layout',
  },
  source: {
    id: 'agendaSummaryBlock.source',
    defaultMessage: 'Agenda',
  },
  sourceDescription: {
    id: 'agendaSummaryBlock.sourceDescription',
    defaultMessage: 'Select the Agenda that will provide today events.',
  },
  sectionTitle: {
    id: 'agendaSummaryBlock.sectionTitle',
    defaultMessage: 'Section title',
  },
  useLightTheme: {
    id: 'agendaSummaryBlock.useLightTheme',
    defaultMessage: 'Use light theme',
  },
  useFullWidth: {
    id: 'agendaSummaryBlock.useFullWidth',
    defaultMessage: 'Use full width',
  },
});

export const agendaSummarySchema = ({ intl }) => ({
  title: intl.formatMessage(messages.blockTitle),
  fieldsets: [
    {
      id: 'default',
      title: intl.formatMessage(messages.blockTitle),
      fields: ['title', 'source'],
    },
    {
      id: 'layout',
      title: intl.formatMessage(messages.layout),
      fields: ['useFullWidth', 'useLightTheme'],
    },
  ],
  properties: {
    title: {
      title: intl.formatMessage(messages.sectionTitle),
    },
    source: {
      title: intl.formatMessage(messages.source),
      description: intl.formatMessage(messages.sourceDescription),
      widget: 'object_browser',
      mode: 'link',
      selectedItemAttrs: ['Title', 'UID'],
      selectableTypes: ['Agenda'],
      allowExternals: false,
    },
    useFullWidth: {
      title: intl.formatMessage(messages.useFullWidth),
      type: 'boolean',
      default: true,
    },
    useLightTheme: {
      title: intl.formatMessage(messages.useLightTheme),
      type: 'boolean',
      defaultValue: false,
    },
  },
  required: ['source'],
});
